<template>
    <div class="content">
      <p class="not-found-404">
        404
      </p>
      <p class="not-found-text">
          Die eingegebene Adresse konnte nicht gefunden werden.
      </p>
    </div>
</template>

<script>
import siteConfig from '@/assets/js/mixins/siteConfig';

export default {
    name: 'pagenotfound',
    data() {
        return {
            notfoundImg: siteConfig.imgUrl + '404.jpg'
        };
    },
};
</script>

<style lang="scss" scoped>
.not-found-404 {
    font-size: 4em;
    font-weight: bold;
    color: coral;
    text-align: center;
    margin-top: 90px;
    margin-bottom: 60px;
}
.not-found-text {
    text-align: center;
}
.not-found-img {
    width: 100%;
    height: 100%;
}
</style>
